import React from 'react';
// logic
import ticketService from 'modules/emergencies/ticketService';
// components
import { FormButton } from '../ui/buttons/FormButton';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import {
  ModalContainer,
  CloseButtonContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
  ModalRegularText,
} from './modalComponents';
import styled from 'styled-components';
import ChangesSummary from '../changesSummary/changesSummary';
import { ReactComponent as ExclamationRedIcon } from 'assets/icons/xpo/status_icons/girded-exclamation-red.svg';

const CustomModalFormContainer = styled(ModalFormContainer)`
  display: flex;
  flex-direction: row;
`;

const WarningContainer = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  ${ModalRegularText} {
    gap: 8px;
    display: flex;
    align-items: center;
    svg {
      width: 14px;
      height: 14px;
    }
  }
`;

const t = {
  confirm: 'Save changes',
  back: 'Back',
  title: 'Do you want to save the changes?',
};
export const ConfirmTicketEditionBeforeAcceptanceModal = ({ ok, cancel, props }) => {
  const { changes, ticket } = props;

  const hasOpenAuctions = ticketService.bussiness.ticketHasOpenAuctions(ticket);
  const hasQuoteSent = ticketService.bussiness.hasQuoteSent(ticket);

  const goBack = (e) => {
    e.preventDefault();
    cancel();
  };
  const formattedTicketId = ticketService.utils.getFormatedId(ticket.id);

  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>{`Ticket ID. ${formattedTicketId}`}</ModalHeaderSecondaryText>
            <ModalHeaderMainText>{t.title}</ModalHeaderMainText>
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <CustomModalFormContainer>
          <ChangesSummary changes={changes} />
        </CustomModalFormContainer>
        <WarningContainer>
          {hasOpenAuctions && (
            <ModalRegularText>
              <ExclamationRedIcon />
              The offer will be unpublished and carriers that have responded will receive a
              rejection message.
            </ModalRegularText>
          )}
          {hasQuoteSent && (
            <ModalRegularText>
              <ExclamationRedIcon />
              The submitted quote will be cancelled and a new quote will need to be created.
            </ModalRegularText>
          )}
        </WarningContainer>
      </ModalBody>
      <ModalFooter>
        <FormButton variant="ghost" onClick={goBack}>
          {t.back}
        </FormButton>
        <FormButton onClick={() => ok()}>{t.confirm}</FormButton>
      </ModalFooter>
      <CloseButtonContainer onClick={goBack}>
        <CloseIcon />
      </CloseButtonContainer>
    </ModalContainer>
  );
};
